import { useTranslations } from "next-intl";
import styles from "./upload-overlay.module.css";

export default function UploadOverlay() {
  const t = useTranslations("ChatsView");
  return (
    <div className={styles.overlay}>
      <div className={styles.frame}>
        <div className={styles.text}>{t("dropFileHere")}</div>
      </div>
    </div>
  );
}
